import { useRemove } from '../state/actions/useRemove';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';

export const useRemoveSendEmailFromWorkflow = () => {
  const { dispatch, state } = useWorkFlowCanvas();
  const remove = useRemove();

  return (id: string) => {
    const { nodes, edges } = Canvas.createFromState(state)
      .removeNode(id)
      .convertToState();

    dispatch({
      type: 'UPDATE',
      payload: {
        nodes,
        edges,
      },
    });

    remove(id);
  };
};
